import { Helmet } from 'react-helmet-async';
// sections
import { ContactView } from 'src/sections/contact/view';

// ----------------------------------------------------------------------

export default function ContactPage() {
  return (
    <>
      <Helmet>
        <title>Contact Us</title>
        <meta
          name="description"
          content="Get in touch with us. We have offices in UAE and Lebanon. Contact our team for any inquiries or support."
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Contact Us | Cartify" />
        <meta
          property="og:description"
          content="Get in touch with us. We have offices in UAE and Lebanon. Contact our team for any inquiries or support."
        />
        <meta property="og:image" content="/assets/images/contact/Hero.png" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Us | Cartify" />
        <meta
          name="twitter:description"
          content="Get in touch with us. We have offices in UAE and Lebanon. Contact our team for any inquiries or support."
        />
        <meta name="twitter:image" content="/assets/images/contact/Hero.png" />

        {/* Additional SEO tags */}
        <meta
          name="keywords"
          content="contact, UAE office, Lebanon office, business contact, get in touch"
        />
        <link rel="canonical" href="/contact-us" />
      </Helmet>

      <ContactView />
    </>
  );
}
